import { MENU_ITEMS } from './pages-menu';

export function findMenuByUrl(url: string): any {

  const flattenMenu = (items: any[]): any[] => {
    let result: any[] = [];

    items.forEach(item => {
      if (item.children) {
        result = result.concat(flattenMenu(item.children));
      }
      if (item.link) {
        result.push(item);
      }
    });

    return result;
  };

  const allMenus = flattenMenu(MENU_ITEMS);

  return allMenus.find(m => url.startsWith(m.link));
}